import { render, staticRenderFns } from "./FlaggedCommentDetailsFormModal.vue?vue&type=template&id=4d25ded8&scoped=true&"
import script from "./FlaggedCommentDetailsFormModal.vue?vue&type=script&lang=ts&"
export * from "./FlaggedCommentDetailsFormModal.vue?vue&type=script&lang=ts&"
import style0 from "./FlaggedCommentDetailsFormModal.vue?vue&type=style&index=0&id=4d25ded8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25ded8",
  null
  
)

export default component.exports